module.exports = "/_next/static/images/cb326d0891f0bcf8e12d7769420de94e-google-store.svg.webp";